import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const travelFeeAPI = {
  calculate: (destinationAddress) => 
    axios.post(`${API}/travel-fee/calculate`, { destination_address: destinationAddress }).then(res => res.data),
};
